import React from "react"
import Link from "gatsby-link"
import cx from "classnames"

import { Detail, H3 } from "../../elements"
import { GridCol3 } from "../../layout"

const sitemap = [
  {
    title: "Röportajlar",
    items: [
      {
        name: "Bütün Röportajlar",
        to: "/roportajlar",
      },
      {
        name: "İtalya'da Astrofizik ve Kozmoloji Alanında Yüksek Lisans Yapmak",
        to: "/roportajlar/italyada-padova-universitesinde-yuksek-lisans-yapmak",
      },
      {
        name: "Şirketim İflas Edince Kendimi Almanya'da Buldum",
        to: "/roportajlar/sirketim-iflas-edince-kendimi-almanyada-buldum",
      },
      {
        name: "Öğrenciliği de İş Hayatını da Japonya'da Deneyimlemek",
        to: "/roportajlar/ogrenciligi-de-is-hayatini-da-japonyada-deneyimlemek",
      },
      {
        name: "İTÜ İnşaat Fakültesi'nden 41 Yaşında Avustralya'ya",
        to: "/roportajlar/itu-insaat-fakultesinden-avustralyaya",
      },
      {
        name: "Green Card ile Amerika'ya Gidip Facebook (Meta) Firmasında Çalışmak",
        to: "/roportajlar/green-card-ile-amerikaya-gidip-facebookta-calismak",
      },
    ],
  },
  {
    title: "Yazılar",
    items: [
      {
        name: "Bütün Yazılar",
        to: "/yazilar",
      },
      {
        name: "Göçmenlik Psikolojisi Hakkında",
        to: "/yazilar/gocmenlik-psikolojisi",
      },
      {
        name: "Yurtdışında Üniversite Okumak",
        to: "/yazilar/yurtdisinda-universite-okumak",
      },
    ],
  },
  {
    title: "Hakkımızda",
    items: [
      {
        name: "Biz Kimiz?",
        to: "/hakkimizda",
      },
      {
        name: "Bize Ulaşın",
        to: "/iletisim",
      },
      {
        name: "Twitter",
        to: "https://twitter.com/Cizzgi__",
        external: true,
      },
      {
        name: "Instagram",
        to: "https://www.instagram.com/cizzgi__/",
        external: true,
      },
    ],
  },
]

type Props = {
  sitemap: any
  className?: string
}

Footer.defaultProps = {
  sitemap: sitemap,
}

function Footer(props: Props) {
  const { sitemap, className } = props

  return (
    <footer className={cx("bg-blue-light", className)}>
      <div className="max-w-screen-lg mx-auto py-7 px-4">
        <GridCol3 className="pb-16">
          {sitemap.map((section: any) => {
            return <Navigation key={section.title} section={section} />
          })}
        </GridCol3>
        <div>
          <Detail className="text-sm text-center">
            <span>
              &copy; {new Date().getFullYear()} Çizzgi - Her Hakkı Saklıdır
            </span>
          </Detail>
        </div>
      </div>
    </footer>
  )
}

function Navigation({ section }: any) {
  return (
    <div>
      <H3 className="mb-6 font-bold text-base">{section.title}</H3>
      <ul>
        {section.items.map((item: any) => {
          return (
            <li key={item.name} className="mb-4">
              {item.external ? (
                <a href={item.to} target="_blank" rel="noopener">
                  <Detail className="text-sm text-gray-dark">
                    {item.name}
                  </Detail>
                </a>
              ) : (
                <Link to={item.to}>
                  <Detail className="text-sm text-gray-dark">
                    {item.name}
                  </Detail>
                </Link>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Footer
